import styled, { css } from 'styled-components';

import { Text, Checkbox } from '@gympass/yoga';
import { AlertCircle, CheckedFull } from '@gympass/yoga-icons';

import Table from 'components/Table';
import * as endUserStyles from 'pages/EndUser/styles';

export const StyledTable = styled(Table)`
  border-collapse: separate;
  border-spacing: ${({ theme }) =>
    `${theme.yoga.spacing.zero} ${theme.yoga.spacing.xsmall}px`};

  thead tr {
    padding: ${({ theme }) => theme.yoga.spacing.zero};
    height: ${({ theme }) => theme.yoga.spacing.xxlarge}px;

    th {
      border-bottom: ${({ theme }) => theme.yoga.borders.small}px solid;
      border-color: ${({ theme }) => theme.yoga.colors.tableBorder};
      padding: ${({ theme }) => theme.yoga.spacing.zero};
      text-transform: none;
      font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
    }
  }

  tbody {
    tr {
      background-color: transparent !important;

      td {
        border-top: ${({ theme }) =>
          `${theme.yoga.borders.small}px solid ${theme.yoga.colors.disabled}`};
        border-bottom: ${({ theme }) =>
          `${theme.yoga.borders.small}px solid ${theme.yoga.colors.disabled}`};
        &:first-child {
          border-left: ${({ theme }) =>
            `${theme.yoga.borders.small}px solid ${theme.yoga.colors.disabled}`};
          border-radius: ${({ theme }) =>
            `${theme.yoga.radii.small}px 0 0 ${theme.yoga.radii.small}px`};
        }

        &:last-child {
          border-right: ${({ theme }) =>
            `${theme.yoga.borders.small}px solid ${theme.yoga.colors.disabled}`};
          border-radius: ${({ theme }) =>
            `0 ${theme.yoga.radii.small}px ${theme.yoga.radii.small}px 0`};
          text-align: center;
        }
      }
    }

    &:before {
      content: '';
      display: block;
      height: ${({ theme }) => theme.yoga.spacing.zero}px;
    }
  }
`;

export const NameColumn = styled.div`
  display: flex;
  align-items: center;
  padding: ${({ theme }) =>
    `${theme.yoga.spacing.small}px ${theme.yoga.spacing.xlarge}px`};
`;

export const PatientAvatar = styled(endUserStyles.EndUserAvatar)`
  width: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  height: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  margin: ${({ theme }) => theme.yoga.spacing.zero};
  background-color: ${({ bgColor }) => bgColor};
  box-shadow: none;
`;

export const PatientAvatarText = styled(endUserStyles.EndUserAvatarText)`
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  text-indent: 0;
`;

export const CentrilizedContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const MoreAttentionTHTitle = styled(Text.Small)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const MoreAttentionTH = styled.div`
  display: flex;
  text-indent: 0;
  align-items: center;
`;

export const StyledSwitch = styled(Checkbox.Switch)`
  ${({ theme, checked }) =>
    checked &&
    css`
      background-color: ${theme.yoga.colors.primaryLight} !important;
    `};
`;

export const StyledAlertCircle = styled(AlertCircle)`
  cursor: pointer;
  display: flex;
  margin-left: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const StyledSessionRenewalBadge = styled(Text.Tiny)`
  color: ${({ theme }) => theme.yoga.colors.feedback.success.dark};
  text-indent: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const StyledCheckedFull = styled(CheckedFull)`
  height: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  width: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  fill: ${({ theme }) => theme.yoga.colors.feedback.success.dark};
`;

export const SessinRenewBadgeContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${({ theme }) => theme.yoga.spacing.large}px;
`;
